import Router from '@pages/admins/roles/create-role'
import EditRole from '@components/admins/edit-role'

export default {
  path: '/roles/create',
  name: 'role-create',
  components: {
    fullscreen: Router,
  },

  children: [{  
    path: ':role_id/infos',
    name: 'role-create-infos',
    components: { 
      default: EditRole,
    },
  }],
}